import React, { useState, useEffect } from 'react';
import { Moon, Sun } from 'lucide-react'; 

const DarkMode = () => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const html = document.documentElement;
    if (isDark) {
      html.classList.add('dark');
    } else {
      html.classList.remove('dark');
    }
  }, [isDark]);

  const DarkModeToggle = () => {
    setIsDark(!isDark);
  };

  return (
    <button
      onClick={DarkModeToggle}
      className="p-2 rounded-full bg-gray-400 dark:bg-gray-800 text-gray-800 dark:text-yellow-400 hover:scale-110 transition-all"
    >
      {isDark ? <Sun className="w-6 h-6" /> : <Moon className="w-6 h-6" />}
    </button>
  );
};

export default DarkMode;

